import { Card, InfoRow, ProgressStat } from './BmsCardPrimitives'

const StatusOverviewCard = ({ bms, className = '' }) => (
  <Card className={className}>
    <ProgressStat label="SoC" value={bms.soc} type="soc" />
    <ProgressStat label="SoH" value={bms.soh} type="soh" />
    <InfoRow label="Pack Voltage" value={bms.packVoltage} />
    <InfoRow label="Pack Current" value={bms.packCurrent} />
  </Card>
)

export default StatusOverviewCard
